import * as qs from 'query-string';

import AuthProvider, { AuthContext } from './context/auth';
import {
  CONTACT_FORM1,
  CONTACT_FORM2,
  CONTACT_FORM3,
  CONTACT_FORM5,
  EVENT,
  FORMPRIZE,
  FORMPRIZE1,
  FORMPRIZE2,
  FORMPRIZE3,
  FORMPRIZE4,
  FORMPRIZE5,
  LANDING_PAGE,
  LANDING_PAGE1,
  LANDING_PAGE2,
  LANDING_PAGE3,
  LANDING_PAGE4,
  LANDING_PAGE5,
  LANDING_PAGE_AUTHEN,
  LOGIN,
  LOTTERY,
  NOT_FOUND_EVENT,
  OVERVIEWTEMPLATE,
  PAT01,
  PAT02,
  PAT03,
  PAT04,
  PAT05,
  PDF_EXPORT,
  PRIZE_WINNERS,
  QUESTIONNAIRE,
  SUCCESSFORM,
  SUCCESSFORM1,
  SUCCESSFORM2,
  SUCCESSFORM3,
  SUCCESSFORM5,
  SUCCESSFORM_SPECIAL,
  USERS,
  VIDEO,
} from './settings/constants';
import React, { Suspense, lazy, useContext } from 'react';
import { Redirect, Route, Switch, useLocation } from 'react-router-dom';

import { InLineLoader } from './components/InlineLoader/InlineLoader';
import Videos from './containers/Videos/Videos';

const Login = lazy(() => import('./containers/Login/Login'));
const Users = lazy(() => import('./containers/Users/Users'));
const Questionnaire = lazy(
  () => import('./containers/Questionnaire/Questionnaire'),
);
const OverviewTemplate = lazy(
  () => import('./containers/OverviewTemplate/OverviewTemplate'),
);
const AdminLayout = lazy(() => import('./containers/Layout/Layout'));
const PrizeWinners = lazy(
  () => import('./containers/PrizeWinners/PrizeWinners'),
);

const Events = lazy(() => import('./containers/Events/Events'));
const Form = lazy(
  () => import('./containers/LandingAlbion/Lottery/LuckyIpad/Form/FormPrize'),
);
const Form2 = lazy(
  () => import('./containers/LandingAlbion2/Lottery/LuckyIpad/Form/FormPrize'),
);
const EventForm = lazy(() => import('./containers/Events/EventForm'));
const ExportQRCode = lazy(() => import('./containers/ExportQRCode'));
const LandingAlbion = lazy(
  () => import('./containers/LandingAlbion/LandingAlbion'),
);

const LandingAlbion2 = lazy(
  () => import('./containers/LandingAlbion2/LandingAlbion'),
);

const SuccessForm = lazy(
  () =>
    import('./containers/LandingAlbion2/Lottery/LuckyIpad/Form/SuccessForm'),
);
// Special layout
// const specialLayoutUrl = "./containers/LandingAlbionSpecial/";
const specialLayoutUrl =
  './landing-new-template/containers/LandingPageSpecial/';
const LandingPageSpecial = lazy(() => import(`${specialLayoutUrl}LandingPage`));
const LandingLotterySpecial = lazy(() => import(`${specialLayoutUrl}Lottery`));

const LandingPageSpecial1 = lazy(
  () => import('./containers/LandingPageSpecial1/LandingAlbion'),
);

const LandingPageSpecial2 = lazy(
  () => import('./containers/LandingPageSpecial2/LandingAlbion'),
);

const LandingPageSpecial3 = lazy(
  () => import('./containers/LandingPageSpecial3/LandingAlbion'),
);

const LandingPageSpecial4 = lazy(
  () => import('./containers/LandingPageSpecial4/LandingAlbion'),
);

const LandingPageSpecial5 = lazy(
  () => import('./containers/LandingPageSpecial5/LandingAlbion'),
);

const FormSpecial = lazy(
  () => import(`${specialLayoutUrl}Lottery/VideoSpin/Form/Contact`),
);
const FormSpecial1 = lazy(
  () =>
    import(
      './containers/LandingPageSpecial1/Lottery/LuckyIpad/Form/FormConfirm'
    ),
);

const FormSpecial2 = lazy(
  () =>
    import(
      './containers/LandingPageSpecial2/Lottery/LuckyIpad/Form/FormConfirm'
    ),
);

const FormSpecial3 = lazy(
  () =>
    import(
      './containers/LandingPageSpecial3/Lottery/LuckyIpad/Form/FormConfirm'
    ),
);

const FormSpecial5 = lazy(
  () =>
    import(
      './containers/LandingPageSpecial5/Lottery/LuckyIpad/Form/FormConfirm'
    ),
);

const SuccessFormSpecial1 = lazy(
  () =>
    import('./containers/LandingPageSpecial1/Lottery/LuckyIpad/Form/Thanks'),
);

const SuccessFormSpecial2 = lazy(
  () =>
    import('./containers/LandingPageSpecial2/Lottery/LuckyIpad/Form/Thanks'),
);

const SuccessFormSpecial3 = lazy(
  () =>
    import('./containers/LandingPageSpecial3/Lottery/LuckyIpad/Form/Thanks'),
);

const SuccessFormSpecial5 = lazy(
  () =>
    import('./containers/LandingPageSpecial5/Lottery/LuckyIpad/Form/Thanks'),
);

const SuccessFormSpecial = lazy(
  () => import(`${specialLayoutUrl}Lottery/VideoSpin/Form/Thanks`),
);

const LandingPageAuthen = lazy(
  () => import('./containers/LandingPageAuthen/LandingPageAuthen'),
);

const NotFoundEvent = lazy(
  () => import('./containers/NotFoundEvent/NotFoundEvent'),
);
// const SuccessFormSpecial = lazy(
//   () => import(`${specialLayoutUrl}Lottery/LuckyIpad/Form/SuccessForm`)
// );
/**
 *
 *  A wrapper for <Route> that redirects to the login
 * screen if you're not yet authenticated.
 *
 */

function PrivateRoute({ children, ...rest }) {
  const { isAuthenticated } = useContext(AuthContext);
  const checkClient = localStorage.role === 'client';
  return (
    <Route
      {...rest}
      render={({ location }) =>
        !isAuthenticated ? (
          <Redirect
            to={{
              pathname: '/login',
              state: { from: location },
            }}
          />
        ) : checkClient && rest.path === USERS ? (
          <Redirect
            to={{
              pathname: '/event',
              state: { from: location },
            }}
          />
        ) : (
          children
        )
      }
    />
  );
}

const Routes = () => {
  const location = useLocation();
  const query = qs.parse(location.search);

  return (
    <AuthProvider>
      <Suspense fallback={<InLineLoader />}>
        <Switch>
          <PrivateRoute exact={true} path={PRIZE_WINNERS}>
            <AdminLayout>
              <Suspense fallback={<InLineLoader />}>
                <PrizeWinners />
              </Suspense>
            </AdminLayout>
          </PrivateRoute>
          <PrivateRoute path={USERS}>
            <AdminLayout>
              <Suspense fallback={<InLineLoader />}>
                <Users />
              </Suspense>
            </AdminLayout>
          </PrivateRoute>
          <PrivateRoute path={EVENT}>
            <AdminLayout>
              <Suspense fallback={<InLineLoader />}>
                {query.type ? <EventForm /> : <Events />}
              </Suspense>
            </AdminLayout>
          </PrivateRoute>
          <PrivateRoute path={QUESTIONNAIRE}>
            <AdminLayout>
              <Suspense fallback={<InLineLoader />}>
                <Questionnaire />
              </Suspense>
            </AdminLayout>
          </PrivateRoute>
          <PrivateRoute path={OVERVIEWTEMPLATE}>
            <AdminLayout>
              <Suspense fallback={<InLineLoader />}>
                <OverviewTemplate />
              </Suspense>
            </AdminLayout>
          </PrivateRoute>
          <Route path={FORMPRIZE}>
            <Suspense fallback={<InLineLoader />}>
              {/* <Form /> */}
              <FormSpecial />
            </Suspense>
          </Route>
          <Route path={CONTACT_FORM1}>
            <Suspense fallback={<InLineLoader />}>
              {/* <Form /> */}
              <FormSpecial1 />
            </Suspense>
          </Route>
          <Route path={CONTACT_FORM2}>
            <Suspense fallback={<InLineLoader />}>
              {/* <Form /> */}
              <FormSpecial2 />
            </Suspense>
          </Route>
          <Route path={CONTACT_FORM3}>
            <Suspense fallback={<InLineLoader />}>
              {/* <Form /> */}
              <FormSpecial3 />
            </Suspense>
          </Route>
          <Route path={CONTACT_FORM5}>
            <Suspense fallback={<InLineLoader />}>
              {/* <Form /> */}
              <FormSpecial5 />
            </Suspense>
          </Route>
          <Route path={SUCCESSFORM1}>
            <Suspense fallback={<InLineLoader />}>
              <SuccessFormSpecial1 />
              {/* <SuccessFormSpecial /> */}
            </Suspense>
          </Route>
          <Route path={SUCCESSFORM2}>
            <Suspense fallback={<InLineLoader />}>
              <SuccessFormSpecial2 />
              {/* <SuccessFormSpecial /> */}
            </Suspense>
          </Route>
          <Route path={SUCCESSFORM3}>
            <Suspense fallback={<InLineLoader />}>
              <SuccessFormSpecial3 />
              {/* <SuccessFormSpecial /> */}
            </Suspense>
          </Route>
          <Route path={SUCCESSFORM5}>
            <Suspense fallback={<InLineLoader />}>
              <SuccessFormSpecial5 />
              {/* <SuccessFormSpecial /> */}
            </Suspense>
          </Route>
          <Route path={FORMPRIZE1}>
            <Suspense fallback={<InLineLoader />}>
              <Form2 />
            </Suspense>
          </Route>
          <Route path={FORMPRIZE2}>
            <Suspense fallback={<InLineLoader />}>
              <Form2 />
            </Suspense>
          </Route>
          <Route path={FORMPRIZE3}>
            <Suspense fallback={<InLineLoader />}>
              <Form2 />
            </Suspense>
          </Route>
          <Route path={FORMPRIZE4}>
            <Suspense fallback={<InLineLoader />}>
              <Form2 />
            </Suspense>
          </Route>
          <Route path={FORMPRIZE5}>
            <Suspense fallback={<InLineLoader />}>
              <Form2 />
            </Suspense>
          </Route>
          <Route path={SUCCESSFORM}>
            <Suspense fallback={<InLineLoader />}>
              <SuccessForm />
              {/* <SuccessFormSpecial /> */}
            </Suspense>
          </Route>
          <Route path={SUCCESSFORM_SPECIAL}>
            <Suspense fallback={<InLineLoader />}>
              <SuccessFormSpecial />
            </Suspense>
          </Route>
          <PrivateRoute path={PDF_EXPORT}>
            <Suspense fallback={<InLineLoader />}>
              <ExportQRCode />
            </Suspense>
          </PrivateRoute>
          <PrivateRoute path={VIDEO}>
            <AdminLayout>
              <Suspense fallback={<InLineLoader />}>
                <Videos />
              </Suspense>
            </AdminLayout>
          </PrivateRoute>
          {/* <Route exact={true} path={LANDING_PAGE}>
            <Suspense fallback={<InLineLoader />}>
              <LandingPage />
            </Suspense>
          </Route> */}
          <Route exact={true} path={`${NOT_FOUND_EVENT}`}>
            <Suspense fallback={<InLineLoader />}>
              <NotFoundEvent />
            </Suspense>
          </Route>
          <Route exact={true} path={`/${LANDING_PAGE_AUTHEN}`}>
            <Suspense fallback={<InLineLoader />}>
              <LandingPageAuthen />
            </Suspense>
          </Route>
          <Route exact={true} path={`/${LANDING_PAGE}`}>
            <Suspense fallback={<InLineLoader />}>
              <LandingPageSpecial />
            </Suspense>
          </Route>
          <Route exact={true} path={`/${LANDING_PAGE}-${PAT01}`}>
            <Suspense fallback={<InLineLoader />}>
              <LandingPageSpecial1 />
            </Suspense>
          </Route>
          <Route exact={true} path={`/${LANDING_PAGE}-${PAT02}`}>
            <Suspense fallback={<InLineLoader />}>
              <LandingPageSpecial2 />
            </Suspense>
          </Route>
          <Route exact={true} path={`/${LANDING_PAGE}-${PAT03}`}>
            <Suspense fallback={<InLineLoader />}>
              <LandingPageSpecial3 />
            </Suspense>
          </Route>
          <Route exact={true} path={`/${LANDING_PAGE}-${PAT04}`}>
            <Suspense fallback={<InLineLoader />}>
              <LandingPageSpecial4 />
            </Suspense>
          </Route>
          <Route exact={true} path={`/${LANDING_PAGE}-${PAT05}`}>
            <Suspense fallback={<InLineLoader />}>
              <LandingPageSpecial5 />
            </Suspense>
          </Route>
          <Route exact={true} path={LOTTERY}>
            <Suspense fallback={<InLineLoader />}>
              <LandingLotterySpecial />
            </Suspense>
          </Route>
          <Route exact={true} path={LANDING_PAGE1}>
            <Suspense fallback={<InLineLoader />}>
              <LandingAlbion2 />
            </Suspense>
          </Route>
          <Route exact={true} path={LANDING_PAGE2}>
            <Suspense fallback={<InLineLoader />}>
              <LandingAlbion2 />
            </Suspense>
          </Route>
          <Route exact={true} path={LANDING_PAGE3}>
            <Suspense fallback={<InLineLoader />}>
              <LandingAlbion2 />
            </Suspense>
          </Route>
          <Route exact={true} path={LANDING_PAGE4}>
            <Suspense fallback={<InLineLoader />}>
              <LandingAlbion2 />
            </Suspense>
          </Route>
          <Route exact={true} path={LANDING_PAGE5}>
            <Suspense fallback={<InLineLoader />}>
              <LandingAlbion2 />
            </Suspense>
          </Route>
          <Route path={LOGIN}>
            <Login />
          </Route>
          <Redirect to={localStorage.role !== 'client' ? USERS : EVENT} />
          {/* <Route component={NotFound} /> */}
        </Switch>
      </Suspense>
    </AuthProvider>
  );
};

export default Routes;
